var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOffRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Time_Off_Request);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #09819a;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Time_Off_Request"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time_Off_Request",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(190.555 -1909.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgPath",
    transform: "translate(-184.5 1922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-2",
    d: "M24.991,42.4a4.436,4.436,0,0,0-2.744,2.388c-.243.529-.278.879-.319,3.132l-.046,2.537L14.9,50.5c-7.786.056-7.562.032-9.556,1A9.52,9.52,0,0,0,.259,57.747C.007,58.732,0,59.16,0,73.922S.007,89.112.259,90.1A9.521,9.521,0,0,0,5.347,96.34c2.179,1.058-.373.968,27.638.968s25.459.089,27.638-.968a9.537,9.537,0,0,0,5.067-6.159,5.362,5.362,0,0,1,.322-1.01c.048-.048.088-6.988.088-15.421s-.039-15.294-.087-15.246-.193-.329-.322-.838A9.535,9.535,0,0,0,60.624,51.5c-1.994-.967-1.769-.944-9.556-1l-6.979-.05-.044-2.537c-.043-2.469-.053-2.556-.4-3.264a4.832,4.832,0,0,0-2.133-2.087c-.594-.274-.712-.279-8.269-.3a76.159,76.159,0,0,0-8.253.135m.792,2.83c-.871.305-.973.612-1.022,3.062l-.043,2.181H41.254l-.043-2.181c-.048-2.45-.151-2.757-1.022-3.062-.624-.219-13.783-.219-14.407,0M8.89,53.431A6.911,6.911,0,0,0,3.033,58.6c-.292,1.241-.292,29.4,0,30.643a6.9,6.9,0,0,0,4.791,4.95,11.531,11.531,0,0,0,1.9.29l1.228.09V53.306l-.676.017c-.372.009-1,.058-1.386.109m4.9,20.491V94.538h2.706V53.306H13.787V73.922m5.541,0V94.538H46.644V53.306H19.328V73.922m30.151,0V94.538h2.706V53.306H49.479V73.922m5.541,0V94.573l1.228-.09a11.531,11.531,0,0,0,1.9-.29,6.9,6.9,0,0,0,4.791-4.95c.292-1.241.292-29.4,0-30.643a6.9,6.9,0,0,0-4.791-4.95,11.53,11.53,0,0,0-1.9-.29l-1.228-.09V73.922m-54.957,0c0,8.469.015,11.933.034,7.7s.019-11.163,0-15.4-.034-.77-.034,7.7",
    transform: "translate(0 -42.258)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-3",
    cx: 23.966,
    cy: 23.966,
    r: 23.966,
    transform: "translate(-154.542 1939.91)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgPath-2",
    "data-name": "svgPath",
    transform: "translate(-152.033 1942.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    className: "cls-2",
    d: "M18.726.245A21.5,21.5,0,0,0,.158,18.852a28.6,28.6,0,0,0,0,5.359,21.487,21.487,0,0,0,17.81,18.5,27.646,27.646,0,0,0,6.079.116A21.425,21.425,0,0,0,42.741,24.1a2.123,2.123,0,0,1,.13-.689,14.172,14.172,0,0,0,.072-1.968,12.752,12.752,0,0,0-.067-1.882,2.51,2.51,0,0,1-.168-.852A21.434,21.434,0,0,0,24.1.242a31.109,31.109,0,0,0-5.37,0m.335,2.931a18.256,18.256,0,0,0-10.671,5.3A18.093,18.093,0,0,0,2.957,21.528a18.483,18.483,0,0,0,8.323,15.453A19.2,19.2,0,0,0,17.415,39.6a19.013,19.013,0,0,0,8.5-.12,18.1,18.1,0,0,0,8.58-4.891A17.479,17.479,0,0,0,38,29.761a18.435,18.435,0,0,0,.081-16.313,19.084,19.084,0,0,0-6.346-7.28,18.417,18.417,0,0,0-7.978-2.994,23.36,23.36,0,0,0-4.7,0m1.757,5.6a1.555,1.555,0,0,0-.7.668c-.124.227-.138.844-.138,6.358v6.107l.2.335a37.131,37.131,0,0,0,3.959,3.338c3.1,2.474,3.828,3.018,4.132,3.088a1.49,1.49,0,0,0,1.792-1.457c0-.651-.182-.834-3.739-3.675l-3.364-2.687-.024-5.578c-.027-6.224.008-5.865-.617-6.343a1.612,1.612,0,0,0-1.5-.154M.066,21.532c0,1.081.012,1.523.027.983s.015-1.425,0-1.966-.027-.1-.027.983",
    transform: "translate(-0.032 -0.128)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOffRequest);
export default __webpack_public_path__ + "static/media/Time_Off_Request.3245c28b0e3a4f7919ec5ed9d6e1a20a.svg";
export { ForwardRef as ReactComponent };